import { IListProps } from './List.component';

export const mapSizeToFontSize: Record<NonNullable<IListProps['size']>, 12 | 14 | 16> = {
  small: 12,
  medium: 14,
  large: 16,
} as const;
